export default "__VITE_ASSET__DbTYMF3r__"